// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DataBaseWorkingClass } from '@shared/commons/DataBase/old/DataBaseWorkingClass';
import { DataBaseActions } from '@shared/commons/DBClasses/DBPrimitives';
import { WorkSpaceMetaData } from './WorkSpaceMetaData';
const DB_NAME = 'WorkSpaces';
class _WorkSpaceDBManager extends DataBaseWorkingClass {
    constructor() {
        super(DB_NAME);
        this.currentWorkspacesKey = 'WorkSpacesUser';
        this.StartWaiter = null;
    }
    InitUserStorage(userKey) {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentWorkspacesKey = userKey;
            this.ClearRefs();
            this.StartWaiter = this.CreateObjectStore(userKey, 'id');
            this.db = yield this.StartWaiter;
            this.db.onversionchange = () => {
                this.ClearRefs();
            };
            return this.db;
        });
    }
    ClearRefs() {
        this.CloseDB();
        this.StartWaiter = null;
    }
    GetStorage(objectStoreKey) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.db === null && this.StartWaiter !== null) {
                this.db = yield this.StartWaiter;
            }
            else if (this.db === null && this.StartWaiter === null) {
                yield this.InitUserStorage(this.currentWorkspacesKey);
            }
            return this.db.transaction(objectStoreKey, 'readwrite').objectStore(objectStoreKey);
        });
    }
    AddWS(key_1, wsData_1) {
        return __awaiter(this, arguments, void 0, function* (key, wsData, fromServer = false) {
            const ws = {
                id: key,
                isActive: false,
                data: wsData,
                updateTimeSpan: +new Date(),
                actionState: fromServer ? DataBaseActions.Update : DataBaseActions.Add,
                locked: false,
                dataToSend: {}
            };
            return yield this.AddToDB(ws, this.currentWorkspacesKey);
        });
    }
    UpdateWS(key_1, updateHandler_1) {
        return __awaiter(this, arguments, void 0, function* (key, updateHandler, actionState = DataBaseActions.Update) {
            const request = yield this.GetFromDB(key, this.currentWorkspacesKey);
            if (isNullOrUndefined(request.result)) {
                return null;
            }
            if (request.result.actionState === DataBaseActions.ToRemove) {
                return request;
            }
            const data = updateHandler(request);
            data.updateTimeSpan = +new Date();
            if (request.result.actionState !== DataBaseActions.Add || actionState === DataBaseActions.ToRemove) {
                data.actionState = actionState;
            }
            const updateRequest = yield this.UpdateEntryInDB(data, this.currentWorkspacesKey);
            return updateRequest;
        });
    }
    changeActive(isActive, request) {
        const tmp = request.result;
        tmp.isActive = isActive;
        this.checkDataToSendExists(tmp);
        tmp.dataToSend.isactive = isActive;
        return tmp;
    }
    changeWSData(wsData, request) {
        const tmp = request.result;
        tmp.data = wsData;
        this.checkDataToSendExists(tmp);
        tmp.dataToSend.data = wsData;
        return tmp;
    }
    changeState(newState, request) {
        const tmp = request.result;
        tmp.actionState = newState;
        return tmp;
    }
    changeLocked(locked, request) {
        const tmp = request.result;
        this.checkDataToSendExists(tmp);
        tmp.dataToSend.locked = locked;
        return tmp;
    }
    cleardataToSend(request) {
        const tmp = request.result;
        this.checkDataToSendExists(tmp);
        tmp.dataToSend = {};
        return tmp;
    }
    changeName(newName, request) {
        const tmp = request.result;
        this.checkDataToSendExists(tmp);
        tmp.dataToSend.name = newName;
        return tmp;
    }
    checkDataToSendExists(data) {
        if (isNullOrUndefined(data.dataToSend)) {
            data.dataToSend = {};
        }
    }
    SaveWorkSpace(key_1, wsData_1) {
        return __awaiter(this, arguments, void 0, function* (key, wsData, fromServer = false) {
            const WS = yield this.GetFromDB(key, this.currentWorkspacesKey);
            if (WS === null) {
                return null;
            }
            if (isNullOrUndefined(WS.result)) {
                yield this.AddWS(key, wsData, fromServer);
            }
            else {
                yield this.UpdateWS(key, (req) => {
                    return this.changeWSData(wsData, req);
                });
            }
        });
    }
    GetWorkSpace(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const WS = yield this.GetFromDB(key, this.currentWorkspacesKey);
            if (WS === null) {
                return null;
            }
            if (isNullOrUndefined(WS.result)) {
                return null;
            }
            return WS.result.data;
        });
    }
    SetActiveWorkSpace(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const allWSreqRes = yield this.GetAllEntriesFromDB(this.currentWorkspacesKey);
            const allWS = allWSreqRes.result;
            for (const ws of allWS) {
                if (ws.isActive === true) {
                    void this.UpdateWS(ws.id, (req) => {
                        return this.changeActive(false, req);
                    });
                }
            }
            const WS = yield this.GetFromDB(key, this.currentWorkspacesKey);
            if (WS === null) {
                return null;
            }
            yield this.UpdateWS(key, (req) => {
                return this.changeActive(true, req);
            });
        });
    }
    RemoveWorkSpace(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const WS = yield this.DeleteFromDB(key, this.currentWorkspacesKey);
            if (WS === null) {
                return null;
            }
        });
    }
    MarkToRemoveWorkSpace(key) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.UpdateWS(key, (req) => {
                return this.changeState(DataBaseActions.ToRemove, req);
            }, DataBaseActions.ToRemove);
        });
    }
    SetDataBaseActionstate(key, newState) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.UpdateWS(key, (req) => {
                return this.changeState(newState, req);
            });
        });
    }
    SetWorkSpaceLocked(key, locked) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.UpdateWS(key, (req) => {
                return this.changeLocked(locked, req);
            });
        });
    }
    SetWorkSpaceName(key, newName) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.UpdateWS(key, (req) => {
                return this.changeName(newName, req);
            });
        });
    }
    ClearWorkSpaceDataToSend(key) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.UpdateWS(key, (req) => {
                return this.cleardataToSend(req);
            });
        });
    }
    GetAllWorkSpaces() {
        return __awaiter(this, void 0, void 0, function* () {
            const allWSreqRes = yield this.GetAllEntriesFromDB(this.currentWorkspacesKey);
            const allWS = allWSreqRes.result;
            return allWS;
        });
    }
    GetAllWorkSpacesIds() {
        return __awaiter(this, void 0, void 0, function* () {
            const allWSreqRes = yield this.GetAllEntriesFromDB(this.currentWorkspacesKey);
            const allWS = allWSreqRes.result;
            const IdsFromDB = [];
            if (allWS !== null) {
                for (const ws of allWS) {
                    if (ws.actionState !== DataBaseActions.ToRemove) {
                        const data = new WorkSpaceMetaData();
                        data.ws_id = ws.id;
                        data.name = ws.data.name;
                        data.updateTimeSpan = ws.updateTimeSpan;
                        data.isActive = ws.isActive;
                        IdsFromDB.push(data);
                    }
                }
            }
            return IdsFromDB;
        });
    }
    getDBWSActiveTime(wsDataArray, activeWsId) {
        for (const wsItem of wsDataArray) {
            if (wsItem.ws_id === activeWsId)
                return wsItem.updateTimeSpan;
        }
        return -1;
    }
    FilterWorkSpacesIds(wsDataArray, activeWsId) {
        return __awaiter(this, void 0, void 0, function* () {
            const IdsFromDB = [];
            let newWSidFromDb = null;
            let isNewActiveWsId = true;
            const dbUpdateTimeSpan = this.getDBWSActiveTime(wsDataArray, activeWsId);
            for (const wsItem of wsDataArray) {
                const wsR = yield this.GetFromDB(wsItem.ws_id, this.currentWorkspacesKey);
                const ws = wsR.result;
                if (isNullOrUndefined(ws)) {
                    if (wsItem.ws_id === activeWsId) {
                        isNewActiveWsId = false;
                    }
                    const data = new WorkSpaceMetaData();
                    data.FillByDataFromServer(wsItem, wsItem.ws_id === activeWsId);
                    IdsFromDB.push(data);
                    continue;
                }
                if (ws.actionState !== DataBaseActions.ToRemove) {
                    if (ws.id === activeWsId && dbUpdateTimeSpan >= ws.updateTimeSpan) {
                        isNewActiveWsId = false;
                        ws.isActive = false;
                    }
                    const data = new WorkSpaceMetaData();
                    data.ws_id = ws.id;
                    data.name = ws.data.name;
                    data.updateTimeSpan = ws.updateTimeSpan;
                    data.isActive = ws.isActive;
                    if (isNewActiveWsId && ws.isActive) {
                        newWSidFromDb = ws.id;
                        isNewActiveWsId = false;
                    }
                    IdsFromDB.push(data);
                }
            }
            return [IdsFromDB, isNewActiveWsId, newWSidFromDb];
        });
    }
    CloneWorkSpace(curWsId, clonedWsId) {
        return __awaiter(this, void 0, void 0, function* () {
            const WS = yield this.GetFromDB(curWsId, this.currentWorkspacesKey);
            if (WS === null) {
                return false;
            }
            if (isNullOrUndefined(WS.result)) {
                return false;
            }
            const WSCloneRes = yield this.AddWS(clonedWsId, WS.result.data);
            if (isNullOrUndefined(WSCloneRes.result)) {
                return false;
            }
            return true;
        });
    }
    ClearAll() {
        return __awaiter(this, void 0, void 0, function* () {
            const workspaces = yield this.GetAllWorkSpaces();
            const prArr = [];
            for (const ws of workspaces) {
                const pr = this.DeleteFromDB(ws.id, this.currentWorkspacesKey);
                prArr.push(pr);
            }
            yield Promise.all(prArr);
            return true;
        });
    }
}
export const WorkSpaceDBManager = new _WorkSpaceDBManager();
